import React, { useState, useContext, useEffect } from "react";
import { useDispatch } from 'react-redux';
import {useNavigate} from 'react-router-dom';
import { toast } from "react-toastify";
import { cartFetch } from "../../features/cartSlice";
import Billsearch from "../bill/Billsearch";
import Billtitle from "../bill/Billtitle";
import Billitems from "../bill/Billitems";
import { useAuth } from "../../hooks/customers/AuthProvider";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import { useTranslation } from "react-i18next";

function Bill() {
  const auth = useAuth();
  const customerId = auth.customer._id;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // State for search input
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // to track if more data is available

  const handleInputChange = (e) => {
    const keayword = e.target.value;
    setSearchTerm(keayword);
  };

  const getOrders = async (pageNum = 1, append = false) => {
    setLoader(true);
    let url = `${ENDPOINTS.SUBMIT_ORDER}/${customerId}?limit=${Config.ORDERS_LIMIT}&page=${pageNum}`;
    if (searchTerm) {
      url = `${url}&reference_no=${searchTerm}`;
    }
    const response = await API.getWithToken(url);
    if (response.statusText === "OK") {
      //console.log(response?.data?.data.orders,'response');
      //setOrders(response?.data?.data.orders);
      const newOrders = response?.data?.data?.orders || [];
      setOrders(prev =>
        append ? [...prev, ...newOrders] : newOrders
      );

      // You can use totalCount or result length to determine if more data exists
      setHasMore(newOrders.length === Config.ORDERS_LIMIT);
    }
    setLoader(false);
  };

  useEffect(() => {
    getOrders(1, false);
  }, []);

  const submitOrder = async (order) => {
    setLoader(true);
    const response = await API.putWithToken(
      `${ENDPOINTS.SUBMIT_CUSTOMER_ORDER}/${order}/${customerId}`,
      { _id: order }
    );
    if (response.statusText === "OK") {
      toast.success(t("order_submitted_for_dm_review"), {
        position: "bottom-left",
      });
      getOrders();
    }
    setLoader(false);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore && !isLoader) {
      const nextPage = page + 1;
      setPage(nextPage);
      getOrders(nextPage, true); // fetch next page, append results
    }
  };


  const deleteOrder = async (order) => {
    setLoader(true);
    const response = await API.deleteWithToken(
      `${ENDPOINTS.SUBMIT_ORDER}/${order}/${customerId}`,
      { _id: order }
    );
    if (response.statusText === "OK") {
      getOrders();
    }
    setLoader(false);
  };

  const editOrder = async (order) => {
    setLoader(true);
    const response = await API.postWithToken(
      `${ENDPOINTS.EDIT_ORDER}/${order}/${customerId}`,
      { order_id: order, customer_id: customerId, action: "edit" }
    );
    if (response.statusText === "OK") {
      dispatch(cartFetch());
      navigate(Config.CART);
    }
    setLoader(false);
  };

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      // getOrders();
      setPage(1);
      getOrders(1, false);
    }, 1000);
    return () => clearTimeout(delayInputTimeoutId);
  }, [searchTerm]);

  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="search_fav customscroll" onScroll={handleScroll}>
          <Billsearch
            handleInputChange={handleInputChange}
            searchTerm={searchTerm}
          />
          <Billtitle />
          {orders.length > 0 && (
            <Billitems
              orders={orders}
              submitOrder={submitOrder}
              deleteOrder={deleteOrder}
              editOrder={editOrder}
            />
          )}
          {!isLoader && orders.length <= 0 && (
            <div className="empty-search-result-wrapper">
              <div className="empty-search-result">
                {t("no_result_found_txt")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Bill;
